import type { auth as en } from '@/i18n/locales/en/auth';
import type { Translation } from '@/i18n/types';

export const auth: Translation<typeof en> = {
  signInFailed: 'Aanmelden mislukt',
  checkingSession: 'Je sessie wordt gecontroleerd…',
  redirectingToSignIn: 'Je wordt doorgestuurd naar aanmelden…',
  signingIn: 'Je wordt aangemeld…',
  backToDashboard: 'Terug naar het dashboard',
};
